export default "__VITE_ASSET__BuyGVQYa__"